<template>
      <v-layout align-center>
        <v-flex xs12 sm8 md8 lg8>
            <v-combobox
                v-model="chips"
                :items="items"
                chips
                clearable
                placeholder="Driver"
                label="Member role"
                multiple
                class="blue--text"
                solo
                disable-lookup
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    class="blue"
                    dark
                    @click="roleSelected(item)"
                >
                  <strong>{{ item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
        </v-flex>
<!--        <div v-for="role in dispatchRoles" :key="role.title">-->
<!--          {{role.title}}-{{role.ratePerHour}}-->
<!--        </div>-->
        <v-dialog v-model="serviceRoleDialog"
                  ref="dialog"
                  persistent
                  width="500px"
        >

          <v-card>
            <v-card-title>
              <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">Set Service Provider Role</div>
            </v-card-title>
            <v-card-text v-if="selectedServiceRole.title">
              <v-divider></v-divider>
              <v-row>
                <v-col cols="4">
                  <v-subheader>Service Provider:</v-subheader>
                </v-col>
                <v-col cols="8">
                  <div class="headline">{{selectedServiceRole.title}}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-subheader>Payout Structure</v-subheader>
                </v-col>
                <v-col cols="8">
                  <v-switch
                      v-model="selectedServiceRole.payoutAtFixedRate"
                      color="blue"
                      label="Fixed amount">
                  </v-switch>
                </v-col>
              </v-row>

              <v-row v-if="selectedServiceRole.payoutAtFixedRate">
                <v-col cols="4">
                  <v-subheader>Fixed rate</v-subheader>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                      label="Fixed rate"
                      v-model="selectedServiceRole.fixedRate"
                      prefix="$"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="4">
                  <v-subheader>Hourly rate</v-subheader>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                      v-model="selectedServiceRole.ratePerHour"
                      label="Hourly rate"
                      prefix="$"
                      suffix="/Hour"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-subheader>Save to Roles List</v-subheader>
                </v-col>
                <v-col cols="8">
                  <v-checkbox
                      color="blue"
                      v-model="selectedServiceRole.savedRole"
                      label="Save role for future use"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-subheader>Delete Permanently</v-subheader>
                </v-col>
                <v-col cols="8">
                 <v-btn
                     outlined
                     class="red--text"
                     @click="removeRole"
                 >Delete</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="serviceRoleDialog = false">cancel</v-btn>
              <v-btn @click="saveServiceRole" class="blue" dark>
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
</template>
<script>
import {doc, updateDoc} from "firebase/firestore";

export default {
  props: ['id', 'dispatchData'],
  data: () => ({
    chips: [],
    items: [],
    dispatchRoles: [],
    userSavedRoles: [],
    selectedServiceRole: {
      title: null,
      ratePerHour: 0,
      fixedRate: 0,
      payoutAtFixedRate: false,
      savedRole: false
    },
    serviceRoleDialog: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    chips (val, prev) {
      // console.log('Current: '+val.length)
      // console.log('Prev: '+prev.length)
      if (val.length > prev.length) {
        // console.log('New role')
        if ((val.length - prev.length) > 1) {
          return
        } else {
          this.handleNewServiceRoles(val[val.length-1])
        }
      }
      if (val.length < prev.length) {
        // console.log('sync roles')
        this.syncDispRolesWithChips()
      }
    },
    // dispatchRoles (val) {
    //   console.log('disp watcher')
    //   console.log(val)
    // }
  },
  created () {
    let data = this.dispatchData
    // set dispatch roles
    let chips = []
    if (data.dispatchRoles) {
      // console.log(data.dispatchRoles)
      this.dispatchRoles = data.dispatchRoles
      // set chips
      data.dispatchRoles.forEach(role => {
        chips.push(role.title)
      })
      this.chips = chips
    }
    // set userSavedRoles
    if (this.user.serviceRoles) {
      let userSavedRoles = this.user.serviceRoles
      this.userSavedRoles = userSavedRoles
      // set items
      let item = []
      userSavedRoles.forEach(role => {
        return item.push(role.title)
      })
      this.items = item
    }
  },
  methods: {
    syncDispRolesWithChips () {
      let dispRoles = this.dispatchRoles
      let newDispRoles = []
      // console.log(this.chips.length)
      if (this.chips.length > 1) {
        this.chips.forEach(chip => {
          for (let i = 0; i < dispRoles.length; i++) {
            if (dispRoles[i].title === chip) {
              newDispRoles.push(dispRoles[i])
            }
          }
        })
      }
      let removedRole
      if (this.chips.length === 1) {
        this.dispatchRoles.forEach(role => {
          if (role.title !== this.chips[0].title) {
            removedRole = role
          }
        })
        console.log(removedRole)
        // let removeChipIndex = this.dispatchRoles.findIndex(removedRole)
        // console.log(removeChipIndex)
      }
      this.dispatchRoles = newDispRoles
      console.log(this.dispatchRoles)
      this.updateDispatchRoles()
    },
    removeRole () {
      let item = this.selectedServiceRole.title
      this.chips.splice(this.chips.indexOf(item), 1)
      let dispRoleObj = this.dispatchRoles.find(obj =>
          obj.title === this.selectedServiceRole.title)
      let roleIndex = this.dispatchRoles.indexOf(dispRoleObj)
      this.dispatchRoles.splice(roleIndex, 1)
      this.updateDispatchRoles()
      this.serviceRoleDialog = false
    },
    roleSelected (role) {
      // console.log(role)
      // console.log(this.dispatchRoles)
      let dispRoleObj = this.dispatchRoles.find(obj => {
          return obj.title === role})
      let roleIndex = this.dispatchRoles.indexOf(dispRoleObj)
      // console.log(roleIndex)
      if (dispRoleObj) {
        // console.log(this.dispatchRoles[roleIndex])
        this.selectedServiceRole = this.dispatchRoles[roleIndex]
        this.serviceRoleDialog = true
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    handleNewServiceRoles (role) {
      // console.log(role)
      let roleObj = this.userSavedRoles.find(obj =>{
          return obj.title === role})
      if (roleObj) {
        this.dispatchRoles.push(roleObj)
        this.selectedServiceRole = roleObj
        // this.serviceRoleDialog = true
        this.updateDispatchRoles()
        // this.$emit('updateDispatchRoles', this.dispatchRoles)
      } else {
        let customObj = {...this.selectedServiceRole}
        customObj.title = role
        this.dispatchRoles.push(customObj)
        this.selectedServiceRole = customObj
        this.serviceRoleDialog = true
        // this.$emit('updateDispatchRoles', this.dispatchRoles)
      }
    },
    permanentlyDeleteRole () {
      // this.removeRole ()
      // service roles are saved under user profile doc
      // to remove existing role:
      // - first check if role is tagged as saved in Roles List
      // --- on open role, check if role title exist in userSavedRoles array
      // ----array gets pulled from user profile
      // - if service role exist display perm delete button
      // - on perm delete find element in array
      // - delete element
      // - set new array to user profile
      // - update user profile
    },
    updateProfile (userData) {
      this.$store.dispatch('updateUserProfile', userData)
    },
    saveServiceRole () {
      if (this.selectedServiceRole.savedRole) {
        console.log(this.selectedServiceRole)
        // service roles are saved under user profile doc
        // to add a new role:
        // - fetch saved roles array from user profile
        let serviceRoles = []
        if (this.user.serviceRoles) {
          serviceRoles = this.user.serviceRoles
          // - search for elements with title equals to title of new role
          let roleFound = serviceRoles.find(role => {
            return role.title === this.selectedServiceRole.title
          })
          // - if exist then overwrite element object with new role data
          if (roleFound) {
            let roleIndex = serviceRoles.indexOf(roleFound)
            serviceRoles[roleIndex] = this.selectedServiceRole
          }
          // - else push new role to user's service role array
          else {
            serviceRoles.push(this.selectedServiceRole)
          }
          let userData = this.user
          userData.serviceRoles = serviceRoles
          this.serviceRoleDialog = false
          this.userSavedRoles = serviceRoles
          let item = []
          this.userSavedRoles.forEach(role => {
            return item.push(role.title)
          })
          this.items = item
          return this.$store.dispatch('updateUserProfile', userData)
        } else {
          serviceRoles.push(this.selectedServiceRole)
          // - set new array to user profile
          let userData = {...this.user}
          // console.log(userData)
          // - set new array to user profile
          userData.serviceRoles = serviceRoles
          this.serviceRoleDialog = false
          this.userSavedRoles = serviceRoles
          let item = []
          this.userSavedRoles.forEach(role => {
            return item.push(role.title)
          })
          this.items = item
          // - update user profile
          return this.$store.dispatch('updateUserProfile', userData)
        }

        // - update user profile
      }
      this.updateDispatchRoles()
      this.serviceRoleDialog = false

    },
    updateDispatchRoles () {
      //update only the service roles under dispatch
      let db = this.$store.state.db
      let dispatchRef = doc(db, 'users', this.user.uid + '/dispatch/' + this.id)
      let updateObj = this.dispatchData
      updateObj.dispatchRoles = this.dispatchRoles
      return updateDoc(dispatchRef, updateObj)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    }
  }

}
</script>

